module.exports = __webpack_public_path__ + "static/0006-c367470d80baaf33555c6f9a51e63c2f.jpg";